import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe, Check } from 'lucide-react';

const LANGS = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
];

const LanguageSwitcher = () => {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="language-switcher-button"
        className="flex items-center gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-full border-2 border-black dark:border-white bg-white dark:bg-[#2D2A26] dark:text-white font-bold hover:bg-[#F0F0F0] dark:hover:bg-[#3D3A36] transition-all hard-shadow-hover text-sm"
        aria-label="Change language"
      >
        <Globe className="w-4 h-4" strokeWidth={2.5} />
        <span className="hidden sm:inline uppercase">{current.code}</span>
      </button>

      {open && (
        <div
          data-testid="language-menu"
          className="absolute right-0 mt-2 w-44 bg-white dark:bg-[#2D2A26] border-2 border-black dark:border-white rounded-xl hard-shadow-lg overflow-hidden z-50"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              data-testid={`language-option-${l.code}`}
              className={`w-full flex items-center justify-between px-4 py-2.5 text-left font-bold text-sm transition-colors ${
                l.code === lang
                  ? 'bg-[#FFE66D] text-black'
                  : 'hover:bg-[#F0F0F0] dark:hover:bg-[#3D3A36] dark:text-white'
              }`}
            >
              <span className="flex items-center gap-2">
                <span>{l.flag}</span>
                {l.label}
              </span>
              {l.code === lang && <Check className="w-4 h-4" strokeWidth={3} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
